import { render } from "./UpdateFacadeInGalleryModal.vue?vue&type=template&id=e66c7902&scoped=true&ts=true&lang=pug"
import script from "./UpdateFacadeInGalleryModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateFacadeInGalleryModal.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateFacadeInGalleryModal.vue?vue&type=style&index=0&id=e66c7902&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e66c7902"]])

export default __exports__